// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '@locus-taxy/neo-ui';

import withErrorBoundary from 'common/components/core/errors/ErrorBoundary';
import ApiErrorScreen from 'common/components/core/errors/APIErrorScreen';

const ErrorScreen = () => {
    const { t } = useTranslation();

    return (
        <ApiErrorScreen
            actionLabel={t('reload')}
            onActionClick={() => window.location.reload()}
            message={t('genericError')}
        />
    );
};

const DefaultErrorBoundary = withErrorBoundary({
    ErrorScreen
})();

const DefaultFallback = () => {
    return <Loader color="blue.500" size="large" width="100%" height="100%" />;
};

export default function lazy<Config, Instance = mixed>(
    component: () => Promise<{
        default: React.AbstractComponent<Config, Instance>
    }>,
    options?: {
        Fallback?: React.AbstractComponent<any>,
        ErrorBoundary?: React.AbstractComponent<any>
    }
): React.AbstractComponent<Config, void> {
    const Component = React.lazy(component);
    const Fallback = options?.Fallback || DefaultFallback;
    const ErrorBoundary = options?.ErrorBoundary || DefaultErrorBoundary;
    const LazyComponent = props => {
        return (
            <ErrorBoundary>
                <React.Suspense fallback={<Fallback />}>
                    <Component {...props} />
                </React.Suspense>
            </ErrorBoundary>
        );
    };
    return LazyComponent;
}
